var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"gradient01"},[_c('div',{staticClass:"navbox"},[_c('router-link',{attrs:{"to":"/","tag":"h1"}},[_c('p',[_vm._v("始壯哥")])]),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/lesson"}},[_vm._v("課程列表")])],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }